import { render, staticRenderFns } from "./AssignToClassDetail.vue?vue&type=template&id=28156665&scoped=true&"
import script from "./AssignToClassDetail.vue?vue&type=script&lang=js&"
export * from "./AssignToClassDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssignToClassDetail.vue?vue&type=style&index=0&id=28156665&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28156665",
  null
  
)

export default component.exports